const normalizeSearchValue = (value = "") => {
  return value
    .toString()
    .replaceAll(" ", "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
};

export const includesOnSearch = (inputValue, fields = []) => {
  const enter = normalizeSearchValue(inputValue);
  const prepare = normalizeSearchValue(fields.flat().join(""));
  return prepare.includes(enter);
};
